import Screen from '../components/Screen';
import { useWorkspace } from '../contexts/WorkspaceContext';

// The workspace's Home screen: whatever widgets it is laid out with. New
// workspaces get the `getting_started` widget at the top of the default layout,
// which guides the first steps and then hides itself.
export default function HomePage() {
  const { workspaceName } = useWorkspace();
  return (
    <Screen
      header={<h2 className="text-xl font-semibold text-graphite">{workspaceName || 'Home'}</h2>}
    />
  );
}
